import {OwayoJSKonfiViewer} from "../owayoJSViewerWithSelObs";
import {HTMLPrinter} from "../../global/htmlprinter";

export class FullscreenViewer {


    public static available():boolean {

        return !!((document.body as any).requestFullScreen || (document.body as any).mozRequestFullScreen || (document.body as any).webkitRequestFullScreen);
    }

    public static changeFullScreen(viewer:OwayoJSKonfiViewer) {

        const shirtDOM = $("#shirt");
        const p = HTMLPrinter;
        const element = document.fullscreenElement || (document as any).webkitCurrentFullScreenElement || (document as any).mozFullScreenElement || (document as any).msFullscreenElement;
        if ( typeof(element) !== "undefined" && element !== null) {
            //wir gehen in den Fullscreenmodus
            switch(element.id) {
                case "konfigurator":
                    viewer.calcViewSize();
                    return;

                case "shirt":
                    $(element).css("width",p.px(document.body.clientWidth));
                    $(element).css("height", p.px(document.body.clientHeight));
                    viewer.renderer.setSize(document.body.clientWidth, document.body.clientHeight);
                    viewer.calcViewSize();
                    viewer.renderer.setClearColor(0,1);
                    $(element).css("border","none");
                    viewer.calcViewSize();
                    break;
                default:
                    return;
            }

        } else {
            viewer.renderer.setClearColor(0,0);
            shirtDOM.css("border","").css("width","").css("height","");

            viewer.calcViewSize();
            viewer.renderer.setSize(shirtDOM[0].clientWidth, shirtDOM[0].clientHeight);
            viewer.calcViewSize();
        }
    }

    public static toggleFullScreen(element) {
        if (!document.fullscreenElement &&    // alternative standard method
            !document.mozFullScreenElement && !document.webkitFullscreenElement && !document.msFullscreenElement ) {  // current working methods
            if (element.requestFullscreen) {
                element.requestFullscreen();
            } else if (element.mozRequestFullScreen) {
                element.mozRequestFullScreen();
            } else if (element.webkitRequestFullscreen) {
                element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
            } else if (element.msRequestFullscreen) {
                element.msRequestFullscreen();
            }
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        }
    }

}
window.FullscreenViewer = FullscreenViewer;
